import axios from "axios"
import ApiStore from "./ApiStore";

export class PettycashDocStore extends ApiStore{
  constructor() {
    

    super()
  }

  newPettycashDoc(completeFunc,errorFunc){
    axios.get('/pettycash/doc/?format=json&new_pc=true')
    .then(function(response){
      //console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      //console.log(error);
      errorFunc(error)
    })
  }

  loadPettycashDoc(pettycashNo,completeFunc,errorFunc){
    axios.get('/pettycash/doc/?format=json&pcNo='+pettycashNo)
    .then(function(response){
      //console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      //console.log(error);
      errorFunc(error)
    })
  }

  loadPettycashDoc(pcNo,completeFunc){
    axios.get('/pettycash/doc/?format=json&pc='+pcNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadRequestPersonList(query,pageNo,completeFunc){
    axios.get('/pettycash/requestpersonlist/?format=json&q='+query+'&page='+pageNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  savePettycashDoc(postData,completeFunc,errorFunc){
    
    //console.log('postData',postData)    
    axios.post('/pettycash/doc/',postData)
    .then(function(response){
      //console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      //console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  
}  

export default new PettycashDocStore()


// WEBPACK FOOTER //
// ./src/stores/PettycashDocStore.js